// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card_180nK","chart":"index_chart_SRBCl","amount":"index_amount_2WsNA","title":"index_title_2cgZU"};